import { render } from "./LoaderCountries.vue?vue&type=template&id=60a4f237&scoped=true"
import script from "./LoaderCountries.vue?vue&type=script&lang=js"
export * from "./LoaderCountries.vue?vue&type=script&lang=js"

import "./LoaderCountries.vue?vue&type=style&index=0&id=60a4f237&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a4f237"]])

export default __exports__